import React, { useState, useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import CuadroEditableTorneo from './CuadroEditableTorneo.js';
import ParticipantesTorneo from './torneo/ParticipantesTorneo.js';
import SedesTorneo from './torneo/SedesTorneo.js';
import PosicionesTorneo from './torneo/PosicionesTorneo.js';
import ListaPartidos from './torneo/ListaPartidos.js';
import FichaSolapas from '../UI/FichaSolapas.js';
import { Partidos as TipoLista } from '../constantes/Filtros.js';
import useGetURL from '../../hooks/useGetURL.js';
import useGetListaURL from '../../hooks/useGetListaURL.js';
import styles from './DatosTorneo.module.css';
import EtapasTorneo from './torneo/EtapasTorneo.js';

const Solapas = {
  DATOS: 'Datos',
  PARTICIPANTES: 'Participantes',
  TABLAS: 'Tablas',
  PARTIDOS: 'Partidos',
};

export const Cuadro = {
  DATOS_BASICOS: 'datosBasicos',
  FECHAS: 'fechas',
};

const DatosTorneo = () => {
  const { idTorneo } = useParams();
  const { state } = useLocation();
  const [torneo, setTorneo] = useState(null);
  const [etapasCompletas, setEtapasCompletas] = useState([]);
  const [etapaSeleccionadaPartidos, setEtapaSeleccionadaPartidos] = useState(null);
  const [etapaSeleccionadaTablas, setEtapaSeleccionadaTablas] = useState(null);
  const { isCargando, erroresGet, fetchData, resetErroresGet } = useGetURL();
  const {
    isCargando: isCargandoEtapas,
    erroresGetLista: erroresEtapas,
    fetchData: fetchEtapas,
    resetErroresGetLista: resetErroresEtapas,
  } = useGetListaURL();
  const esNuevo = state && state.nuevo;

  useEffect(() => {
    resetErroresGet();
    resetErroresEtapas();
  }, [resetErroresGet, resetErroresEtapas]);

  useEffect(() => {
    if (idTorneo) {
      fetchData('torneos/' + idTorneo, setTorneo);
      fetchEtapas('torneos/' + idTorneo + '/lista_etapas', setEtapasCompletas);
    } else {
      setTorneo(null);
      setEtapasCompletas([]);
    }
  }, [fetchData, fetchEtapas, idTorneo]);

  // Etapas para Tablas: solo aquellas con cantidadFechas > 1
  const etapasTablas = etapasCompletas.filter((e) => e.cantidadFechas && e.cantidadFechas > 1);

  // Determinar si mostrar la solapa de Tablas
  const listaSolapas = [
    { nombre: Solapas.DATOS, visible: true },
    { nombre: Solapas.PARTICIPANTES, visible: true },
    { nombre: Solapas.TABLAS, visible: etapasTablas.length > 0 },
    { nombre: Solapas.PARTIDOS, visible: true },
  ];

  const onEtapaSeleccionadaPartidos = (etapa) => {
    setEtapaSeleccionadaPartidos(etapa);
  };

  const onEtapaSeleccionadaTablas = (etapa) => {
    setEtapaSeleccionadaTablas(etapa);
  };

  const mostrarDatosSolapa = (solapa) => {
    const datosElegidos = {
      pais: torneo?.pais,
      division: torneo?.division,
      categoria: torneo?.categoria,
      torneo,
    };

    switch (solapa) {
      case Solapas.DATOS: {
        return (
          <div className={`${styles.columnas}`}>
            <div className={`${styles.columnaDoble}`}>
              <CuadroEditableTorneo cuadro={Cuadro.DATOS_BASICOS} torneo={torneo} nuevo={esNuevo} />
              <CuadroEditableTorneo cuadro={Cuadro.FECHAS} torneo={torneo} nuevo={esNuevo} />
              {torneo && !torneo.tipoTorneo?.oficialidad?.dePais && (
                <SedesTorneo datosElegidos={datosElegidos} />
              )}
            </div>
          </div>
        );
      }
      case Solapas.PARTICIPANTES: {
        return (
          <div className={`${styles.columnas}`}>
            <div className={`${styles.columnaSimple}`}>
              <ParticipantesTorneo datosElegidos={datosElegidos} />
            </div>
          </div>
        );
      }
      case Solapas.TABLAS: {
        // Si solo hay una etapa, no mostrar el selector
        if (etapasTablas.length === 1) {
          return (
            <div className={`${styles.columnas}`}>
              <div className={`${styles.columnaSimple}`}>
                <PosicionesTorneo datosElegidos={{ ...datosElegidos, etapa: etapasTablas[0] }} />
              </div>
            </div>
          );
        }

        // Si hay más de una etapa, mostrar el selector
        return (
          <div className={`${styles.columnas}`}>
            <div className={`${styles.columnaEtapa}`}>
              <EtapasTorneo
                etapas={etapasTablas}
                etapaSeleccionada={etapaSeleccionadaTablas}
                onEtapaSeleccionada={onEtapaSeleccionadaTablas}
                isCargando={isCargandoEtapas}
                errores={erroresEtapas}
              />
            </div>
            <div className={`${styles.columnaSimple}`}>
              <PosicionesTorneo
                datosElegidos={{ ...datosElegidos, etapa: etapaSeleccionadaTablas }}
              />
            </div>
          </div>
        );
      }
      case Solapas.PARTIDOS: {
        // Si no hay etapas, mostrar todos los partidos del torneo sin el cuadro de etapas
        if (etapasCompletas.length === 0) {
          return (
            <div className={`${styles.columnas}`}>
              <div className={`${styles.columnaSimple}`}>
                <ListaPartidos tipoLista={TipoLista.TORNEO} datosElegidos={datosElegidos} />
              </div>
            </div>
          );
        }

        // Si hay etapas, mostrar el cuadro de etapas y filtrar por etapa seleccionada
        return (
          <div className={`${styles.columnas}`}>
            <div className={`${styles.columnaEtapa}`}>
              <EtapasTorneo
                etapas={etapasCompletas}
                etapaSeleccionada={etapaSeleccionadaPartidos}
                onEtapaSeleccionada={onEtapaSeleccionadaPartidos}
                isCargando={isCargandoEtapas}
                errores={erroresEtapas}
              />
            </div>
            <div className={`${styles.columnaSimple}`}>
              <ListaPartidos
                tipoLista={TipoLista.ETAPA}
                datosElegidos={{ ...datosElegidos, etapa: etapaSeleccionadaPartidos }}
              />
            </div>
          </div>
        );
      }
      default: {
        return null;
      }
    }
  };

  const nombreTorneo = (torneo) => {
    if (!torneo) return '';
    return torneo.descripcion || '';
  };

  return (
    <FichaSolapas
      item={torneo}
      titulo={nombreTorneo(torneo)}
      solapas={listaSolapas}
      solapaInicial={Solapas.DATOS}
      isCargando={isCargando}
      errores={erroresGet}
      mostrarDatosSolapa={mostrarDatosSolapa}
    />
  );
};

export default DatosTorneo;
